import React from 'react';
const App = () => (
  <div>
    <h1>landing</h1>
  </div>
)
export default App;